export default "https://assets.egbcdn.net/assets/packs/_/images/crypto-logotypes/dash-dash-logo-6ceefd6f31621596e7714677207bdc1c.png";